import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import { ResponseApi } from '../BaseApi';
import { errorMsg } from '../../Apis/functions';

const CommonsSlice = createSlice({
    name: 'commons',
    initialState: {
        deleteItemsApi: null,
        getAllMedia: [],
        getUserFullInformation: [],
        updateUserProfile: [],
        webSocketGuard: [],
        getFilterForEntitiesWithSoftDelete: [],
        idSet: '',
        getListStatus: [],
    },
    reducers: {
        clearUserInformation: (state, action) => {
            state.getUserFullInformation = [];
        },
        setIdSet: (state, action) => {
            state.idSet = action.payload;
        },
        IsDevelopment: (state, { payload }) => {
            state.development = payload;
        },
    },

    extraReducers: {
        'commons/deleteItemsApi/fulfilled': (state, action) => {
            const { data, status, code, showToast } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.deleteItemsApi = data || true;
                if(showToast) toast.success(t('has_been_deleted_successfully'));
            } else if (code >= 400) {
                errorMsg(code);
            }
        },
        'commons/getAllMedia/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllMedia = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'commons/getUserFullInformation/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getUserFullInformation = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'commons/getFilterForEntitiesWithSoftDelete/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getFilterForEntitiesWithSoftDelete = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'commons/getSoftDeletedRecordsByTable/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getSoftDeletedRecordsByTable = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'commons/hardDeleteRecordsByTableAndIds/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.hardDeleteRecordsByTableAndIds = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'commons/restoreRecords/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.restoreRecords = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'commons/updateUserProfile/fulfilled': (state, action) => {
            const { data, status} = action.payload || {};
            if (status >= 200 && status < 300) {
                state.updateUserProfile = data?.data;
                toast.success(t('has_been_updated_successfully').toUpperCase());
            }else {
                errorMsg(data?.code);
        }
        },
        'commons/webSocketGuard/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.webSocketGuard = data;
            } else if (status >= 400 && status < 600) {
            }
        },
        'commons/getListStatus/fulfilled': (state, action) => {
            state.getListStatus = ResponseApi(action.payload);
        },
        clearUserInformation: (state) => {
            state.getUserFullInformation = [];
        },
    },
});

export const { clearUserInformation, setIdSet, IsDevelopment } = CommonsSlice.actions;

export default CommonsSlice.reducer;
